import type { CinematicSettings } from '../domain/cinematic-plan';
import type { StudioDraft } from './studio-draft';
import { withPresentationAppearance } from '../../../renderer/src/presentation-appearance';
import { mapTrackDefault } from './map-track-default';

const startingKeys = { cameraGimbal: 'cameraGimbal', cameraStyle: 'camera', cameraDistance: 'distance', cameraAngle: 'cameraAngle',
  mapStyle: 'mapStyle', depthOfField: 'depthOfField' } as const;

/** Routes an attribute edit to its starting value or one existing waypoint. */
export function changeWaypointSetting<K extends keyof CinematicSettings>(draft: StudioDraft, id: string | null,
  key: K, value: CinematicSettings[K]): StudioDraft {
  if (id === null && key === 'cameraZoom') return draft;
  if (id === null && key === 'mapStyle') return { ...mapTrackDefault(draft, draft.mapStyle, value as string), mapStyle: value as StudioDraft['mapStyle'] };
  if (id === null && key === 'presentationAppearance') return { ...draft, appearances: Object.fromEntries(
    Object.entries(draft.appearances).map(([id, appearance]) => [id, { ...appearance,
      presentation: withPresentationAppearance(appearance.presentation, value as CinematicSettings['presentationAppearance']) }])) };
  if (id === null) return { ...draft, [startingKeys[key as keyof typeof startingKeys]]: value };
  return { ...draft, cinematicSequence: { ...draft.cinematicSequence,
    waypoints: draft.cinematicSequence.waypoints.map(item => item.id === id
      ? { ...item, overrides: { ...item.overrides, [key]: value } } : item) } };
}

/** Removing an override restores inheritance, including an explicit Automatic angle. */
export function inheritWaypointSetting(draft: StudioDraft, id: string, key: keyof CinematicSettings): StudioDraft {
  return { ...draft, cinematicSequence: { ...draft.cinematicSequence,
    waypoints: draft.cinematicSequence.waypoints.map(item => {
      if (item.id !== id) return item;
      const overrides = { ...item.overrides };
      delete overrides[key];
      return { ...item, overrides };
    }) } };
}
